import React, { useState } from "react";
import {
  Col,
  Container,
  Image,
  Row,
  Button,
  Card,
  Form,
} from "react-bootstrap";
import { toast } from "react-toastify";
import { Post } from "../Axios/AxiosFunctions";
import { apiHeader, URL, validateEmail } from "../Config/apiUrl";
const Formb = () => {
  const [isApiCall, setIsApiCall] = useState(false);
  const [input, setInput] = useState({
    name: "",
    lastname: "",
    email: "",
    contactNo: "",
    message: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput({ ...input, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const url = URL(`general/support`);
    const params = {
      name: input?.name.trim(),
      email: input?.email.trim(),
      message: input?.message.trim(),
    };

    for (let key in params) {
      if (params[key] == "") {
        return toast.warn(`${key} can not be empty.`);
      }
    }

    if (!validateEmail(params?.email)) {
      return toast.warn("Please input a valid email address.");
    }

    if (params?.message?.length < 10) {
      return toast.warn("Message should be atleast 10 characters long.");
    }

    setIsApiCall(true);
    const response = await Post(url, params, apiHeader());
    setIsApiCall(false);
    if (response !== undefined) {
      toast.success(
        "Thankyou for contacting Jobster! Our team will respond you shortly."
      );
      setInput({
        name: "",
        lastname: "",
        email: "",
        contactNo: "",
        message: "",
      });
    }
  };

  return (
    <Container className="small_container home_form">
      <Row>
        <Col md={6} className="home_form_left">
          <h3 className="mb-4">Contact Us</h3>

          <p className="mb-5">
            If you need further information about our platform, do not hesitate
            to contact us. I'm ready by the phone.
          </p>
          <p>
            We can book an online meeting so we can demonstrate the platform's
            features to you!
          </p>
        </Col>

        <Col md={6}>
          <form onSubmit={handleSubmit}>
            <Row>
              <Col md={12}>
                <Form.Control
                  className="mini_field"
                  type="text"
                  placeholder="First Name"
                  name="name"
                  value={input.name}
                  required
                  onChange={handleChange}
                />
              </Col>
              {/* <Col md={6}>
                <Form.Control
                  className="mini_field"
                  type="text"
                  placeholder="Last Name"
                  name="lastname"
                  value={input.lastname}
                  required
                  onChange={handleChange}
                />
              </Col> */}
              <Col md={12}>
                <Form.Control
                  className="mini_field"
                  placeholder="Email Address"
                  name="email"
                  value={input.email}
                  required
                  onChange={handleChange}
                />
              </Col>
              {/* <Col md={6}>
                <Form.Control
                  className="mini_field"
                  placeholder="Contact Number"
                  name="contactNo"
                  value={input.contactNo}
                  required
                  onChange={handleChange}
                />
              </Col> */}
              <Col md={12}>
                <Form.Control
                  className="textarea_field"
                  as="textarea"
                  placeholder="Message"
                  name="message"
                  value={input.message}
                  required
                  onChange={handleChange}
                />
              </Col>
              <div>
                <Button disabled={isApiCall} type="submit">
                  {isApiCall ? "Please Wait..." : "Submit"}
                </Button>
              </div>
            </Row>
          </form>
        </Col>
      </Row>
    </Container>
  );
};

export default Formb;
